import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { UserNotificationView } from "./UserNotificationView";
import { UserNotificationViewStore } from "../../store/UserNotificationViewStore";
import { useStore } from "../../../../hooks";

export const UserNotificationViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/userNotification/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new UserNotificationViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <UserNotificationView userNotificationViewStore={store} />
      </PageLayout>
    </div>
  );
});
